<template>
    <div v-show="visible">
        <el-dialog title="选择带有指标的子目录" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div class="container">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.title" placeholder="目录指标库"></el-input>
                    </div>
                </div>
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  @click="add()">确定</el-button>
                </div>

                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    v-loading="loading"
                    height="460"
                    :default-expand-all="true"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border
                    fit highlight-current-row
                    :tree-props="{children: 'children'}"
                    @row-click="handleSelectionChange">
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="text" label="目录指标库"  :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                common:{
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    title:"",
                },
                data:[],
                types:[{
                    value: 0,
                    label: '全部'
                },{
                    value: 1,
                    label: '表扬'
                },{
                    value: 2,
                    label: '待改进'
                }],
                id:"",
                title:"",
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(deptId){
                this.visible=true
                this.id = ""
                this.title = ""
                this.form.deptId=deptId
                
                // 获取数据列表
                this.data=[]
                this.getData()
            },
            indexMethod(index) {
                return (index+1);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateIndicatorsDefineTreeListUrl;
                let data = {
                    deptId:this.form.deptId,
                    title:this.form.title,
                    indicatorsType:1,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }else{
                    return true;
                }
            },
            handleSelectionChange(row, column, event){
                this.id=row.id;
                this.title=row.text;

            },
            add(){
                this.$parent.setEvaluate(this.id,this.title);
                this.visible=false; 
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classset/EvaluateIndicatorsDefine.vue